/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// messageType prop necessary to provide specific styles to the activity Error Message.
export const GenericMessageWrapper = styled.div<{
  messageType?: string;
}>(props => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',

  padding:
    props.messageType === 'activity'
      ? `${gridSize() * 2}px ${gridSize()}px ${gridSize() * 2 - 4}px`
      : `${gridSize() * 3}px ${gridSize()}px`,

  textAlign: 'center',

  'p + button': {
    marginTop: `${gridSize()}px`,
  },
}));

export const GenericMessageHeader = styled.h5({
  font: token('font.heading.xsmall'),
  alignItems: 'center',
  display: 'flex',
});

export const GenericMessageTitle = styled.span({
  paddingLeft: `${gridSize() / 2}px`,
  paddingRight: `${gridSize() / 2}px`,
});
